// extracted by mini-css-extract-plugin
export default {"dropdown":"Style_dropdown__eJ4cO","trigger":"Style_trigger__J9C-K","menu":"Style_menu__UMORt","menuItem":"Style_menuItem__7Xvqu","danger":"Style_danger__y8me-"};